<template lang="pug">
div(:class="$vuetify.breakpoint.mobile ? 'pa-0' : 'pa-8'")
  div(:class="$vuetify.breakpoint.mobile ? 'd-flex align-center flex-nowrap overflow-x-auto gap-2 mb-4' : ''")
    range-dropdown-mobile(v-if="dates && $vuetify.breakpoint.mobile")
    div.d-flex.align-center.gap-2(:class="$vuetify.breakpoint.mobile ? '' : 'mb-6'")
      template(v-if="!$vuetify.breakpoint.mobile")
        div.text-3xl.font-semibold Sales
        v-spacer
      company-dropdown(v-if="isHq")
      provider-dropdown.mr-2
      range-dropdown(v-if="dates && !$vuetify.breakpoint.mobile")

  sales-section(v-if="dates")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import RangeDropdown from './RangeDropdown.vue'
import RangeDropdownMobile from './RangeDropdownMobile.vue'
import ProviderDropdown from './ProviderDropdown.vue'
import SalesSection from './SalesSection.vue'
import CompanyDropdown from '@/components/hq/custom/CompanyDropdown.vue'

export default {
  name: 'InsightSales',
  components: { RangeDropdown, RangeDropdownMobile, ProviderDropdown, SalesSection, CompanyDropdown },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      dates: 'insight/getDates',
      selectedCompanies: 'insight/getSelectedCompanies',
      isHq: 'hq/getIsHq'
    }),
  },
  created () {
    this.setupDates()
  },
  methods: {
    ...mapActions(['showMessage']),
    setupDates () {
      if (this.dates) {
        return
      }
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const yesterday = now.minus({ days: 1 })
      this.$store.commit('insight/setDates', [yesterday.toFormat(dateFormat), yesterday.toFormat(dateFormat)])
      this.$store.commit('insight/setCurrentDateRange', { id: 'yesterday', name: 'Yesterday' })
    },
  }
}
</script>